import { useState, useEffect } from "react";
import { stampsAPI } from "../services/api";

export const useStamps = (type = null) => {
  const [stamps, setStamps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStamps = async () => {
    try {
      setLoading(true);
      console.log("🔄 Загружаем печати...");
      const response = await stampsAPI.getAll(type);
      console.log("✅ Печати загружены:", response.data.stamps);
      setStamps(response.data.stamps);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error("❌ Ошибка загрузки печатей:", err);
      console.error("Детали:", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteStamp = async (id) => {
    try {
      await stampsAPI.delete(id);
      await fetchStamps();
    } catch (err) {
      console.error("Ошибка удаления печати:", err);
      throw err;
    }
  };

  useEffect(() => {
    fetchStamps();
  }, [type]);

  return { stamps, loading, error, refetch: fetchStamps, deleteStamp };
};
